import React from 'react'
// import quote from "../assets/images/quote.png"
import user from "../../assets/images/user/user1.png"
import { AiFillStar } from 'react-icons/ai'
import { LiaGreaterThanSolid, LiaLessThanSolid } from 'react-icons/lia'
import bg from "../../assets/images/bg.png"
import bg1 from "../../assets/images/Rectangle1.png"
import bg2 from "../../assets/images/Rectangle2.png"
import bg3 from "../../assets/images/Rectangle3.png"


import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import Header2 from '../../Layout/Header2'

import "./review.css"
export default function Review() {


    const settings = {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: true,
        initialSlide: 2,
    };

    return (
        <div>
            <Header2 />
            <section className="section bg-gradient-new-reverse pricing pt-5" id="pricing">
                <div className="bg-shape" />
                <div className="container mt-4">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="">
                                <h1 className="whychoose1">Review and download your favourite headshots from a collection of 100+</h1>
                                <p className="craft"> Explore the impact of new headshots an people's lives.</p>
                            </div>
                        </div>
                        <div className='col-lg-2 d-flex'>
                            <div className=" ms-3 text-center d-flex justify-content-center align-items-center" style={{ width: "55px", height: "55px", borderRadius: "50%", background: "linear-gradient(to right, #FC4A1A ,#F7B733)" }}>
                                <span className='image-swiper-button-next'>
                                    <LiaLessThanSolid color='white' size={25} />
                                </span>
                            </div>
                            <div className=" ms-3 text-center d-flex justify-content-center align-items-center" style={{ width: "55px", height: "55px", borderRadius: "50%", background: "linear-gradient(to right, #FC4A1A ,#F7B733)" }}>
                                <span className='image-swiper-button-prev'>
                                    <LiaGreaterThanSolid color='white' size={25} />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End col */}
                <div className='w-100 mt-4'>


                    <Swiper
                        breakpoints={{
                            576: {

                                slidesPerView: 2,
                            },
                            768: {

                                slidesPerView: 2,
                            },
                            1024: {

                                slidesPerView: 4,
                            },
                        }}


                        {...settings}

                        navigation={{
                            nextEl: ".image-swiper-button-next",
                            prevEl: ".image-swiper-button-prev",
                            disabledClass: "swiper-button-disabled"
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        modules={[Pagination, Navigation]}
                        className="mySwiper"

                    >
                        <SwiperSlide>
                            {/* <div className="col-lg-4 col-md-6"> */}

                            <div className="reviewpad h-100 mx-1 cardbg">
                                <div className="headpad">
                                    <p className="great">Great Plat Form</p>
                                </div>
                                <div className="card-body d-flex">
                                    <div className='mx-2'>
                                        <div className='text-center' >
                                            <img src={bg} alt='' width={20} />
                                            {/* <BiSolidQuoteAltLeft size={30} /> */}
                                        </div>
                                    </div>
                                    <p className="save">

                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                                        ligula eget dolor. Aenean massa.
                                    </p>

                                </div>
                                <hr />

                                <div className="mt-2">
                                    <div className="d-flex align-items-center justify-content-center">
                                        <div className="flex-shrink-0">
                                            <img
                                                className="avatar-sm rounded-circle img-fluid"
                                                src={user}
                                                alt=""
                                            />
                                        </div>
                                        <div className=" ms-3">
                                            <p className="mb-0 name"> Brandon Carney</p>
                                            <p className="text-muted mb-0 fs-14"><AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End card */}
                            {/* </div> */}

                        </SwiperSlide>
                        <SwiperSlide>
                            {/* <div className="col-lg-4 col-md-6"> */}

                            <div className="reviewpad card  h-100 mx-1 cardbg">
                                <div className="headpad">
                                    <p className="great">Great Plat Form</p>
                                </div>
                                <div className="card-body d-flex">
                                    <div className='mx-2'>
                                        <div className='text-center' >
                                            <img src={bg} alt='' width={20} />
                                            {/* <BiSolidQuoteAltLeft size={30} /> */}
                                        </div>
                                    </div>
                                    <p className="save">

                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                                        ligula eget dolor. Aenean massa.
                                    </p>

                                </div>
                                <hr />

                                <div className="mt-2">
                                    <div className="d-flex align-items-center justify-content-center">
                                        <div className="flex-shrink-0">
                                            <img
                                                className="avatar-sm rounded-circle img-fluid"
                                                src={bg1}
                                                alt=""
                                            />
                                        </div>
                                        <div className=" ms-3">
                                            <p className="mb-0 name"> Claire Chow</p>
                                            <p className="text-muted mb-0 fs-14"><AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End card */}
                            {/* </div> */}

                        </SwiperSlide>
                        <SwiperSlide>
                            {/* <div className="col-lg-4 col-md-6"> */}

                            <div className="reviewpad card  h-100 mx-1 cardbg">
                                <div className="headpad">
                                    <p className="great">Great Plat Form</p>
                                </div>
                                <div className="card-body d-flex">
                                    <div className='mx-2'>
                                        <div className='text-center' >
                                            <img src={bg} alt='' width={20} />
                                            {/* <BiSolidQuoteAltLeft size={30} /> */}
                                        </div>
                                    </div>
                                    <p className="save">

                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                                        ligula eget dolor. Aenean massa.
                                    </p>

                                </div>
                                <hr />

                                <div className="mt-2">
                                    <div className="d-flex align-items-center justify-content-center">
                                        <div className="flex-shrink-0">
                                            <img
                                                className="avatar-sm rounded-circle img-fluid"
                                                src={bg2}
                                                alt=""
                                            />
                                        </div>
                                        <div className=" ms-3">
                                            <p className="mb-0 name"> John jeskl</p>
                                            <p className="text-muted mb-0 fs-14"><AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End card */}
                            {/* </div> */}

                        </SwiperSlide>
                        <SwiperSlide>
                            {/* <div className="col-lg-4 col-md-6"> */}

                            <div className="reviewpad card  h-100 mx-1 cardbg">
                                <div className="headpad">
                                    <p className="great">Great Plat Form</p>
                                </div>
                                <div className="card-body d-flex">
                                    <div className='mx-2'>
                                        <div className='text-center' >
                                            <img src={bg} alt='' width={20} />
                                            {/* <BiSolidQuoteAltLeft size={30} /> */}
                                        </div>
                                    </div>
                                    <p className="save">

                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                                        ligula eget dolor. Aenean massa.
                                    </p>

                                </div>
                                <hr />

                                <div className="mt-2">
                                    <div className="d-flex align-items-center justify-content-center">
                                        <div className="flex-shrink-0">
                                            <img
                                                className="avatar-sm rounded-circle img-fluid"
                                                src={bg3}
                                                alt=""
                                            />
                                        </div>
                                        <div className=" ms-3">
                                            <p className="mb-0 name">Stan Hesk</p>
                                            <p className="text-muted mb-0 fs-14"><AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End card */}
                            {/* </div> */}

                        </SwiperSlide>
                        <SwiperSlide>
                            {/* <div className="col-lg-4 col-md-6"> */}

                            <div className="reviewpad card h-100 mx-1 cardbg">
                                <div className="headpad">
                                    <p className="great">Great Plat Form</p>
                                </div>
                                <div className="card-body d-flex">
                                    <div className='mx-2'>
                                        <div className='text-center' >
                                            <img src={bg} alt='' width={20} />
                                            {/* <BiSolidQuoteAltLeft size={30} /> */}
                                        </div>
                                    </div>
                                    <p className="save">

                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                                        ligula eget dolor. Aenean massa.
                                    </p>

                                </div>
                                <hr />

                                <div className="mt-2">
                                    <div className="d-flex align-items-center justify-content-center">
                                        <div className="flex-shrink-0">
                                            <img
                                                className="avatar-sm rounded-circle img-fluid"
                                                src={user}
                                                alt=""
                                            />
                                        </div>
                                        <div className=" ms-3">
                                            <p className="mb-0 name">Claire Chow</p>
                                            <p className="text-muted mb-0 fs-14"><AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End card */}
                            {/* </div> */}

                        </SwiperSlide>
                        <SwiperSlide>
                            {/* <div className="col-lg-4 col-md-6"> */}

                            <div className="reviewpad card h-100 mx-1 cardbg">
                                <div className="headpad">
                                    <p className="great">Great Plat Form</p>
                                </div>
                                <div className="card-body d-flex">
                                    <div className='mx-2'>
                                        <div className='text-center' >
                                            <img src={bg} alt='' width={20} />
                                            {/* <BiSolidQuoteAltLeft size={30} /> */}
                                        </div>
                                    </div>
                                    <p className="save">

                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                                        ligula eget dolor. Aenean massa.
                                    </p>

                                </div>
                                <hr />

                                <div className="mt-2">
                                    <div className="d-flex align-items-center justify-content-center">
                                        <div className="flex-shrink-0">
                                            <img
                                                className="avatar-sm rounded-circle img-fluid"
                                                src={bg1}
                                                alt=""
                                            />
                                        </div>
                                        <div className=" ms-3">
                                            <p className="mb-0 name"> Stan Hesk</p>
                                            <p className="text-muted mb-0 fs-14"><AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End card */}
                            {/* </div> */}

                        </SwiperSlide>
                        <SwiperSlide>
                            {/* <div className="col-lg-4 col-md-6"> */}

                            <div className="reviewpad card  h-100 mx-1 cardbg">
                                <div className="headpad">
                                    <p className="great">Great Plat Form</p>
                                </div>
                                <div className="card-body d-flex">
                                    <div className='mx-2'>
                                        <div className='text-center' >
                                            <img src={bg} alt='' width={20} />
                                            {/* <BiSolidQuoteAltLeft size={30} /> */}
                                        </div>
                                    </div>
                                    <p className="save">

                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                                        ligula eget dolor. Aenean massa.
                                    </p>

                                </div>
                                <hr />

                                <div className="mt-2">
                                    <div className="d-flex align-items-center justify-content-center">
                                        <div className="flex-shrink-0">
                                            <img
                                                className="avatar-sm rounded-circle img-fluid"
                                                src={bg2}
                                                alt=""
                                            />
                                        </div>
                                        <div className=" ms-3">
                                            <p className="mb-0 name"> Brandon Carney</p>
                                            <p className="text-muted mb-0 fs-14"><AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End card */}
                            {/* </div> */}

                        </SwiperSlide>
                        <SwiperSlide>
                            {/* <div className="col-lg-4 col-md-6"> */}

                            <div className="reviewpad card  h-100 mx-1 cardbg">
                                <div className="headpad">
                                    <p className="great">Great Plat Form</p>
                                </div>
                                <div className="card-body d-flex">
                                    <div className='mx-2'>
                                        <div className='text-center' >
                                            <img src={bg} alt='' width={20} />
                                            {/* <BiSolidQuoteAltLeft size={30} /> */}
                                        </div>
                                    </div>
                                    <p className="save">

                                        Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                                        ligula eget dolor. Aenean massa.
                                    </p>

                                </div>
                                <hr />

                                <div className="mt-2">
                                    <div className="d-flex align-items-center justify-content-center">
                                        <div className="flex-shrink-0">
                                            <img
                                                className="avatar-sm rounded-circle img-fluid"
                                                src={bg3}
                                                alt=""
                                            />
                                        </div>
                                        <div className=" ms-3">
                                            <p className="mb-0 name"> Brandon Carney</p>
                                            <p className="text-muted mb-0 fs-14"><AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> <AiFillStar color='#FFC700' /> </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* End card */}
                            {/* </div> */}

                        </SwiperSlide>


                        {/* End card */}


                    </Swiper>
                </div>

                {/* End row */}

                {/* End container */}
            </section>
            {/* <Footer/> */}
        </div>
    )
}
